module.exports = __webpack_public_path__ + "img/smart-agriculture.c14df300.webp";